// client/src/components/lookup/LookupForm.tsx
import React from 'react';
import { LookupCategory } from '../../../types/lookup';

interface Props {
  value: string;
  displayName: string;
  sessionRate?: number;
  numberOfSessions?: number;
  sortOrder?: number;
  category: LookupCategory;
  onChange: (field: string, value: string | number) => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  isEditing?: boolean;
}

export const LookupForm: React.FC<Props> = ({
  value,
  displayName,
  sessionRate,
  numberOfSessions,
  sortOrder,
  category,
  onChange,
  onSubmit,
  isSubmitting,
  isEditing = false
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="grid grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium theme-text-primary mb-2">Value</label>
          <input
            type="text"
            value={value}
            onChange={(e) => onChange('value', e.target.value)}
            className="theme-input w-full p-2 border rounded-lg"
            required
            disabled={isSubmitting}
          />
        </div>

        <div>
          <label className="block text-sm font-medium theme-text-primary mb-2">Display Name</label>
          <input
            type="text"
            value={displayName}
            onChange={(e) => onChange('displayName', e.target.value)}
            className="theme-input w-full p-2 border rounded-lg"
            required
            disabled={isSubmitting}
          />
        </div>

        <div>
          <label className="block text-sm font-medium theme-text-primary mb-2">Sort Order</label>
          <input
            type="number"
            value={sortOrder || ''}
            onChange={(e) => onChange('sortOrder', parseInt(e.target.value))}
            className="theme-input w-full p-2 border rounded-lg"
            min="0"
            step="1"
            disabled={isSubmitting}
          />
        </div>
      </div>

      {category === 'organisations' && (
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium theme-text-primary mb-2">Session Rate (£)</label>
            <input
              type="number"
              value={sessionRate || ''}
              onChange={(e) => onChange('sessionRate', parseFloat(e.target.value))}
              className="theme-input w-full p-2 border rounded-lg"
              min="0"
              step="0.01"
              required
              disabled={isSubmitting}
            />
          </div>

          <div>
            <label className="block text-sm font-medium theme-text-primary mb-2">Number of Sessions</label>
            <input
              type="number"
              value={numberOfSessions || ''}
              onChange={(e) => onChange('numberOfSessions', parseInt(e.target.value))}
              className="theme-input w-full p-2 border rounded-lg"
              min="1"
              required
              disabled={isSubmitting}
            />
          </div>
        </div>
      )}

      <button
        type="submit"
        disabled={isSubmitting}
        className={`theme-button-primary px-6 py-2 rounded-lg ${isSubmitting ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        {isSubmitting ? (isEditing ? 'Saving...' : 'Adding...') : (isEditing ? 'Save' : 'Add')}
      </button>
    </form>
  );
};
